import { Number, Record, Static } from "runtypes";

export const SeasonSportRequest = Record({
  schoolId: Number,
  seasonId: Number,
  sportId: Number,
});

export interface ISeasonSportRequest
  extends Static<typeof SeasonSportRequest> {}



// WEBPACK FOOTER //
// ./src/services/ISeasonSportRequest.ts